import { Static, Type } from '@sinclair/typebox';

export const OutboxCronDateTriggerSchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.String(),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('cron'),
  type: Type.Literal('cron.date-trigger'),
  payload: Type.Object({
    startedAt: Type.Date(),
  }),
});

export type OutboxCronDateTrigger = Static<typeof OutboxCronDateTriggerSchema>;

export const OutboxDataTriggerInvocationSchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.String(),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('data-trigger'),
  type: Type.Literal('data-trigger.invocation'),
  payload: Type.Object({
    startedAt: Type.Date(),
    triggerId: Type.String(),
    lowerDateLimit: Type.Optional(Type.Date()),
    upperDateLimit: Type.Optional(Type.Date()),
    lowerCursorLimit: Type.Optional(Type.String()),
    upperCursorLimit: Type.Optional(Type.String()),
    importId: Type.Optional(Type.String()),
  }),
});

export type OutboxDataTriggerInvocation = Static<
  typeof OutboxDataTriggerInvocationSchema
>;

export const OutboxFeedbackTriggerInvocationSchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.String(),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('feedback-trigger'),
  type: Type.Literal('feedback-trigger.invocation'),
  payload: Type.Object({
    startedAt: Type.Date(),
    triggerId: Type.String(),
    lowerDateLimit: Type.Optional(Type.Date()),
    upperDateLimit: Type.Optional(Type.Date()),
    lowerCursorLimit: Type.Optional(Type.String()),
    upperCursorLimit: Type.Optional(Type.String()),
    importId: Type.Optional(Type.String()),
  }),
});

export type OutboxFeedbackTriggerInvocation = Static<
  typeof OutboxFeedbackTriggerInvocationSchema
>;

export const OutboxDataSplitterInvocationSchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.String(),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('data-splitter'),
  type: Type.Literal('data-splitter.invocation'),
  payload: Type.Object({
    startedAt: Type.Date(),
    splitterId: Type.String(),
    lowerDateLimit: Type.Optional(Type.Date()),
    upperDateLimit: Type.Optional(Type.Date()),
    lowerCursorLimit: Type.Optional(Type.String()),
    upperCursorLimit: Type.Optional(Type.String()),
    importId: Type.Optional(Type.String()),
  }),
});

export type OutboxDataSplitterInvocation = Static<
  typeof OutboxDataSplitterInvocationSchema
>;

export const OutboxDataSourceRowInvocationSchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.String(),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('data-source-row'),
  type: Type.Literal('data-source-row.triggered'),
  payload: Type.Object({
    sourceId: Type.String(),
    sourceKind: Type.Union([Type.Literal('data'), Type.Literal('accounts')]),
    triggerId: Type.String({ format: 'uuid' }),
    splitterId: Type.Optional(Type.String({ format: 'uuid' })),
    invocationId: Type.Optional(Type.String({ format: 'uuid' })),
  }),
});

export type OutboxDataSourceRowInvocation = Static<
  typeof OutboxDataSourceRowInvocationSchema
>;

export const OutboxDataSourceFileImportSchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.String({ format: 'uuid' }),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('data-source'),
  type: Type.Literal('data-source.file-import'),
  payload: Type.Object({
    sourceId: Type.String({ format: 'uuid' }),
    importId: Type.String({ format: 'uuid' }),
    fileName: Type.String(),
    triggerId: Type.Optional(Type.String({ format: 'uuid' })),
    splitterId: Type.Optional(Type.String({ format: 'uuid' })),
  }),
});

export const OutboxNotificationScheduleDeliverySchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.String({ format: 'uuid' }),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('notification'),
  type: Type.Literal('notification.schedule-delivery'),
  payload: Type.Any(), // TODO: define payload
});

export type OutboxDataSourceFileImport = Static<
  typeof OutboxDataSourceFileImportSchema
>;

export const OutboxDataNotificationDeliverySchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.String({ format: 'uuid' }),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('notification'),
  type: Type.Literal('notification.delivery'),
  payload: Type.Any(), // TODO: define payload
});

export type OutboxDataNotificationDelivery = Static<
  typeof OutboxDataNotificationDeliverySchema
>;

export const OutboxNotificationSendEmailSchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.Literal('notification.email'),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('notification'),
  type: Type.Literal('notification.send-email'),
  payload: Type.Object({
    to: Type.String(),
    from: Type.Optional(Type.String()),
    subject: Type.String(),
    body: Type.String(),
    // channelId: Type.String({ format: 'uuid' }),
  }),
});

export type OutboxNotificationSendEmail = Static<
  typeof OutboxNotificationSendEmailSchema
>;

export const OutboxNotificationScheduleAutoEmailTaskSchema = Type.Object({
  id: Type.Number(),
  aggregateId: Type.Literal('notification.email'),
  createdAt: Type.Date(),

  aggregateType: Type.Literal('notification'),
  type: Type.Literal('notification.schedule-auto-email-task'),
  payload: Type.Any(), // TODO: define payload
});

export const OutboxSchema = Type.Union([
  OutboxCronDateTriggerSchema,
  OutboxDataTriggerInvocationSchema,
  OutboxFeedbackTriggerInvocationSchema,
  OutboxDataSplitterInvocationSchema,
  OutboxDataSourceRowInvocationSchema,
  OutboxDataSourceFileImportSchema,
  OutboxDataNotificationDeliverySchema,
  OutboxNotificationScheduleDeliverySchema,
  OutboxNotificationSendEmailSchema,
  OutboxNotificationScheduleAutoEmailTaskSchema,
]);

export type Outbox = Static<typeof OutboxSchema>;
